import { render, staticRenderFns } from "./Model6.vue?vue&type=template&id=664d4502&scoped=true"
import script from "./Model6.vue?vue&type=script&lang=js"
export * from "./Model6.vue?vue&type=script&lang=js"
import style0 from "./Model6.vue?vue&type=style&index=0&id=664d4502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d4502",
  null
  
)

export default component.exports